import { makeVar } from '@apollo/client'

export const workspaceLoadingState = makeVar<boolean>(false)

export const setWorkspaceLoadingState = (value: boolean) => {
    workspaceLoadingState(value)
}
